import React, { useState } from "react";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const Contact = () => {
  const [formData, setFormData] = useState({
      name: "",
      email: "",
      message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      try {
          await api.post("/contact", formData);
          toast.success("Message sent successfully. We'll be in touch.", {
              style: { background: "#CCFF00", color: "black" }
          });
          setFormData({ name: "", email: "", message: "" });
      } catch (error) {
          console.error("Submission error:", error);
          toast.error(error.response?.status === 429
              ? "Too many messages. Please wait a few minutes."
              : "Failed to send message. Please try again.");
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <section id="contact" className="min-h-screen bg-black flex flex-col justify-center px-4 md:px-20 py-20 relative">
      <div className="max-w-7xl w-full mx-auto border-t border-white/20 pt-12 md:pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
            <div>
                <h2 className="text-4xl sm:text-5xl md:text-8xl font-display font-bold text-white mb-6 md:mb-8">
                    LET'S <br /> CREATE <br /> <span className="text-stroke">IMPACT.</span>
                </h2>
                <a href="mailto:hello@xluma.in" className="text-lg md:text-2xl font-mono text-gray-400 hover:text-accent transition-colors flex items-center gap-4 hover-trigger break-all">
                    hello@xluma.in <ArrowUpRight className="flex-shrink-0" />
                </a>
            </div>

            <div className="flex flex-col justify-end">
                <form onSubmit={handleSubmit} className="space-y-8 md:space-y-12">
                    <div className="group relative">
                        <input 
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            type="text" 
                            placeholder="Name" 
                            className="w-full bg-transparent border-b border-white/20 py-3 md:py-4 text-lg md:text-2xl text-white outline-none focus:border-accent transition-colors rounded-none placeholder:text-gray-700 font-display uppercase" 
                        />
                    </div>
                    <div className="group relative">
                        <input 
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            type="email" 
                            placeholder="Email" 
                            className="w-full bg-transparent border-b border-white/20 py-3 md:py-4 text-lg md:text-2xl text-white outline-none focus:border-accent transition-colors rounded-none placeholder:text-gray-700 font-display uppercase" 
                        />
                    </div>
                     <div className="group relative">
                        <textarea 
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                            placeholder="Message" 
                            rows="3" 
                            className="w-full bg-transparent border-b border-white/20 py-3 md:py-4 text-lg md:text-2xl text-white outline-none focus:border-accent transition-colors rounded-none placeholder:text-gray-700 font-display uppercase resize-none"
                        ></textarea>
                    </div>
                    
                    <button 
                        disabled={isSubmitting}
                        className="w-full py-4 md:py-6 bg-white hover:bg-accent text-black font-display font-bold text-lg md:text-xl uppercase tracking-widest transition-colors hover-trigger flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isSubmitting ? (
                            <>
                                <Loader2 className="animate-spin" /> Sending...
                            </>
                        ) : (
                            "Send Request"
                        )}
                    </button>
                </form>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
